import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import "@/App.css";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { Overview } from "@/components/site/Overview";
import { Stats } from "@/components/site/Stats";
import { Services } from "@/components/site/Services";
import { Products } from "@/components/site/Products";
import { Solutions } from "@/components/site/Solutions";
import { Showcase } from "@/components/site/Showcase";
import { Contact } from "@/components/site/Contact";
import { WhatsAppFloat } from "@/components/site/WhatsAppFloat";
import LocalLanding from "@/pages/LocalLanding";

function useLenis() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    const onClick = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const id = a.getAttribute("href");
      if (id.length > 1) {
        const el = document.querySelector(id);
        if (el) {
          e.preventDefault();
          lenis.scrollTo(el, { offset: -74 });
        }
      }
    };
    document.addEventListener("click", onClick);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      document.removeEventListener("click", onClick);
    };
  }, []);
}

function HomePage() {
  useEffect(() => {
    document.title = "SATCOM MEDIA TEKNOLOGI — CCTV, WiFi, Parabola & Teknologi Rangkasbitung, Lebak";
    const hash = window.location.hash;
    if (hash && hash.length > 1) {
      setTimeout(() => {
        const el = document.querySelector(hash);
        if (el) (window.__lenis ? window.__lenis.scrollTo(el, { offset: -74 }) : el.scrollIntoView());
      }, 400);
    }
  }, []);

  return (
    <div className="App bg-white text-[#111827] antialiased overflow-x-hidden">
      <Navbar />
      <main>
        <Hero />
        <Overview />
        <Stats />
        <Services />
        <Products />
        <Solutions />
        <Showcase />
        <Contact />
      </main>
      <WhatsAppFloat />
    </div>
  );
}

function App() {
  useLenis();
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/layanan/:slug" element={<LocalLanding />} />
        <Route path="*" element={<HomePage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
